import { render, staticRenderFns } from "./imgViewer.vue?vue&type=template&id=906ab1e6&"
import script from "./imgViewer.vue?vue&type=script&lang=js&"
export * from "./imgViewer.vue?vue&type=script&lang=js&"
import style0 from "./imgViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports